export default __webpack_public_path__ + "static/media/36I-102816_-16013_0.df6d157e.jpg";